import React, { useEffect } from 'react';
import useStyles from '../../Styles';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { trackPromise } from 'react-promise-tracker';
import { onError } from 'src/store/actions/popupActions';
import { PPA_CONTRACT_CLICKED, RETRIEVE_PPA_CONTRACTS_SUCCESS } from 'src/store/PpaContract/PpaContractActionTypes';
import axios from '../../axios/AxiosInterceptors';

const PpaContractList = (props) => {

    const classes = useStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const ppaContracts = useSelector(state => state.ppaContract.ppaContracts);

    useEffect(() => {
        retrieveAccounts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params])


    const retrieveAccounts = async () => {
        await trackPromise(axios.get("/account-service/v1/account/" + params.accountId + "/ppa").then(response => {
            if(response.data) {
                dispatch({type: RETRIEVE_PPA_CONTRACTS_SUCCESS, ppaContracts: response.data});
            }
        }).catch(error => {
            dispatch(onError(error.response));
        }));
    }

    const handleTableRowClick = (ppaContract) => {
        dispatch({type: PPA_CONTRACT_CLICKED, ppaContract: ppaContract})
        history.push("/ppa-contract/account/" + params.accountId + "/ppa/" + ppaContract.id);
    }

    return (
        <main className={classes.layout}>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item align="center" xs={6} sm={4}>
                    <Button onClick={() => history.push("/ppa-contract/account/" + params.accountId + "/ppa/create")}>Create PPA</Button>
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
            <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Generator</TableCell>
                            <TableCell>Off Taker Name</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>End Date</TableCell>
                            <TableCell>Delivery Point PNode</TableCell>
                            <TableCell>Settlement Type</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ppaContracts && ppaContracts.map(r => {
                            return (
                                <TableRow key={r.id} className={classes.tableRow} onClick={(ppaContract) => handleTableRowClick(r)}>
                                    <TableCell>{r.ppaGenerator ? r.ppaGenerator.generatorName : ''}</TableCell>
                                    <TableCell>{r.offtakerName}</TableCell>
                                    <TableCell>{r.startDate}</TableCell>
                                    <TableCell>{r.endDate}</TableCell>
                                    <TableCell>{r.deliveryPointPnode}</TableCell>
                                    <TableCell>{r.settlementType}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </main>
    )

}

export default PpaContractList;